// Reseñas en Google (1-oct-2026) — lealify-base /google-reviews/*. El envío lo hace el
// servidor (lib/googleReviewAsks.js); aquí solo se ven los números y se cambian los ajustes.
import { baseApi } from './baseClient';

export type GRRating = 'excelente' | 'bueno';
export interface GRConfig {
  enabled: boolean; mode: 'shadow' | 'live'; hasPlace: boolean; googleUrl: string | null;
  afterVisits: number; delayMin: number; ratings: GRRating[];
  /** Texto propio del negocio (null = el de fábrica). Variables: @nombre @marca @enlace. */
  template: string | null; defaultTemplate: string; brandName: string | null;
}
export interface GRRow { id: string; contactId: string; name: string; status: 'sent' | 'shadow' | 'failed'; rating: string | null; at: string; clickedAt?: string; detail?: string }
export interface GRStat { day: string; rating: string | null; total: number | null }
export interface GRSummary {
  config: GRConfig;
  whatsapp?: { connected: boolean };
  totals: { enviadas: number; sombra: number; fallidas: number; clics: number };
  google: { first: GRStat; last: GRStat; points: GRStat[] } | null;
  rows: GRRow[];
  rowsTotal?: number;
  your_level?: string;
}
export interface GRAsk { status: 'sent' | 'shadow'; rating: string | null; at: string; clickedAt: string | null }

export const googleReviewsApi = {
  summary: () => baseApi.get<GRSummary>('/google-reviews/settings'),
  save: (patch: Partial<Pick<GRConfig, 'enabled' | 'afterVisits' | 'delayMin' | 'ratings' | 'template'>>) =>
    baseApi.put<{ config: GRConfig }>('/google-reviews/settings', patch),
  asks: (p: { page: number; size: number; clicked?: boolean }) =>
    baseApi.get<{ rows: GRRow[]; total: number }>(`/google-reviews/asks?page=${p.page}&size=${p.size}${p.clicked ? '&clicked=1' : ''}`),
  contact: (id: string) => baseApi.get<{ ask: GRAsk | null }>(`/google-reviews/contact/${encodeURIComponent(id)}`),
};
